import { Badge, FlexBox } from '@dixa/lib-shared-habla';
import { Message } from 'lib-shared-legacy-types';
import { useMemo } from 'react';

import TextMessage, { TextMessageProps } from './TextMessage';
import { useTranslatePlainTextConversationMessage } from './utils/useTranslatePlainTextConversationMessage';

type MessageTranscriptProps = {
  message: Message;
} & TextMessageProps;

export const MessageTranscript = (
  props: MessageTranscriptProps,
): JSX.Element => {
  const { button, translation } = useTranslatePlainTextConversationMessage({
    text: props.message.text ?? undefined,
    isDisabled: false,
    originalLanguageCode: props.message.language ?? null,
    contentType: props.message.content_type === 'Html' ? 'html' : 'text',
  });

  const nameMenuContent = useMemo(() => {
    return (
      <FlexBox gap="200" alignItems="center">
        {props.nameMenu}
        <Badge size="small" variant="info">
          Transcribed
        </Badge>
      </FlexBox>
    );
  }, [props.nameMenu]);

  // Exclude date from props to hide timestamp for transcripts
  // Also exclude content to allow translations to work through markup
  const { date, content, ...restProps } = props;

  return (
    <TextMessage
      {...restProps}
      gutterButtons={button}
      translation={translation}
      nameMenu={nameMenuContent}
    />
  );
};
